import { Global } from "../../Global";
// 全局头像变量
const mockAvatar = 'https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/b0/b041e158ffd1eb3cbc961d8f285c1639e1e32dcce0cb9cdcd25c1effe2096f78.jpg';

// 创建卖家详细信息mock数据
const sellerInfoMocks = [
  {
    sellerId: '1001',
    nickname: '卖家一',
    avatarUrl: mockAvatar,
    wechatId: 'seller1001',
    tiktokId: 'tiktok1001',
    phone: '13900001001',
    gender: 'male',
    sellerLevel: 8,
    sellerCredit: '极好',
    deposit: 10000,
    updateTime: new Date().toISOString(),
    fansCount: 2389,
    productCount: 45,
    praiseCount: 892,
    commentCount: 1023,
    score: 4.8,
    fiveStarCount: 756,
    totalSalesCount: 1289,
    taskCompleteRate: 0.98,
    creditScore: 95, 
    buyerCount: 986,
    isFollowed: true,
    school: '清华大学',
    educationTier: '本科',
    major: '计算机科学与技术'
  },
  {
    sellerId: '1002',
    nickname: '卖家二',
    avatarUrl: mockAvatar,
    wechatId: 'seller1002',
    tiktokId: 'tiktok1002',
    phone: '13900001002',
    gender: 'female',
    sellerLevel: 6,
    sellerCredit: '优秀',
    deposit: 8000,
    updateTime: new Date().toISOString(),
    fansCount: 1256,
    productCount: 28,
    praiseCount: 445,
    commentCount: 567,
    score: 4.5,
    fiveStarCount: 389,
    totalSalesCount: 678,
    taskCompleteRate: 0.95,
    creditScore: 88, 
    buyerCount: 523,
    isFollowed: false,
    school: '北京大学',
    educationTier: '硕士',
    major: '经济学'
  },
  {
    sellerId: '1003',
    nickname: '卖家三',
    avatarUrl: mockAvatar,
    wechatId: 'seller1003',
    tiktokId: 'tiktok1003',
    phone: '13900001003',
    gender: 'male',
    sellerLevel: 4,
    sellerCredit: '较好',
    deposit: 5000,
    updateTime: new Date().toISOString(),
    fansCount: 678,
    productCount: 15,
    praiseCount: 234,
    commentCount: 345,
    score: 4.2,
    fiveStarCount: 198,
    totalSalesCount: 456,
    taskCompleteRate: 0.92,
    creditScore: 82, 
    buyerCount: 289,
    isFollowed: true,
    school: '复旦大学',
    educationTier: '博士',
    major: '金融学'
  },
  {
    sellerId: '1004',
    nickname: '卖家四',
    avatarUrl: mockAvatar,
    wechatId: 'seller1004',
    tiktokId: 'tiktok1004',
    phone: '13900001004',
    gender: 'female',
    sellerLevel: 3,
    sellerCredit: '一般',
    deposit: 3000,
    updateTime: new Date().toISOString(),
    fansCount: 345,
    productCount: 8,
    praiseCount: 123,
    commentCount: 167,
    score: 3.9,
    fiveStarCount: 89,
    totalSalesCount: 234,
    taskCompleteRate: 0.88,
    creditScore: 75, 
    buyerCount: 156,
    isFollowed: false,
    school: '上海交通大学',
    educationTier: '本科',
    major: '电子信息工程'
  }
];

Global.setMockData('getSellerInfo', sellerInfoMocks);   